/* eslint-disable @typescript-eslint/explicit-function-return-type */
import VConsole from 'vconsole';
import { disableShare, getClientEnv, themeInit } from '../utils/common';
import SentryRun from '../utils/sentry';

window.onload = function() {
  var timing = performance.timing;
  console.log(
    '准备新页面时间耗时: ' + (timing.fetchStart - timing.navigationStart)
  );
  console.log(
    'redirect 重定向耗时: ' + (timing.redirectEnd - timing.redirectStart)
  );
  console.log(
    'Appcache 耗时: ' + (timing.domainLookupStart - timing.fetchStart)
  );
  console.log(
    'unload 前文档耗时: ' + (timing.unloadEventEnd - timing.unloadEventStart)
  );
  console.log(
    'DNS 查询耗时: ' + (timing.domainLookupEnd - timing.domainLookupStart)
  );
  console.log('TCP连接耗时: ' + (timing.connectEnd - timing.connectStart));
  console.log('request请求耗时: ' + (timing.responseEnd - timing.requestStart));
  console.log('白屏时间: ' + (timing.responseStart - timing.navigationStart));
  console.log(
    '请求完毕至DOM加载: ' + (timing.domInteractive - timing.responseEnd)
  );
  console.log('解释dom树耗时: ' + (timing.domComplete - timing.domInteractive));
  console.log(
    '从开始至load总耗时: ' +
      (timing.loadEventEnd
        ? timing.loadEventEnd - timing.navigationStart
        : null)
  );
};
// 默认开启功能，如果不要请在调用参数时传入对应参数
/*
 案例：
import InitRun from '../../common/initial'; // 请引入正确路径
InitRun({
  // 禁用sentry
  disabledKey: ['sentry']
}); 
*/
const defInitials = {
  disabledShare: () => {
    disableShare();
  },
  vconsole: () => {
    if (
      process.env.NODE_ENV === 'development' ||
      getClientEnv() === 'test' ||
      getClientEnv() === 'deploy'
    ) {
      new VConsole();
    }
  },
  sentry: () => {
    SentryRun();
  },
  theme: () => {
    themeInit();
  }
};
// 提供页面初始化统一操作
const InitialManager = (opt: any = {}) => {
  const { disabledKey = [] } = opt;

  for (let key in defInitials) {
    if (disabledKey.indexOf(key) > -1) continue;
    const fn = defInitials[key];
    fn(opt[key]);
  }
};

export default InitialManager;
